<script lang="ts">
  import Spacer from "@/components/spacer.svelte";
  import { Col, Container, Row } from "sveltestrap";
  import { Button } from "sveltestrap";
</script>

<div class="smart-main">
  <!-- <img src="/images/common/product_banner.jpg" alt="배너 이미지" /> -->
  <img
    class="comsoon"
    src="/images/common/comming_soon.jpg"
    alt="사후관리 시스템 제품소개 이미지"
  />
  <Spacer size="5rem" />
</div>

<style lang="scss">
  .smart-main {
    text-align: center;
    width: 100%;
    margin-left: 50%;
    transform: translate(-50%, 10px);
  }
  .video {
    width: 80%;
    margin-left: 10%;
  }
  @media (min-width: 768px) {
    .smart-main {
      width: 1000px !important;
    }
    .video {
      width: 100% !important;
      margin-left: 0% !important;
    }
  }
  .video {
    padding: 0px;
  }
</style>
